// JQ4-29 — US-TICKETS-009: useElapsed — live-ticking elapsed time hook.
//
// Design D5: the server returns raw UTC timestamps; the client computes elapsed
// and re-renders on a 1s interval so the displayed number ticks live between polls.
//
// The hook is NOT unit-tested (React hook, needs DOM/jsdom).
// Pure logic is tested via pickElapsedAnchor + formatElapsed (elapsed.test.ts).

import { useEffect, useState } from 'react';

import { formatElapsed } from './elapsed';

/**
 * Returns a formatted elapsed string that ticks every second.
 *
 * @param anchorIso ISO UTC timestamp string (e.g. from pickElapsedAnchor)
 * @returns         Formatted string like "3:47" or "1:02:15"
 */
export function useElapsed(anchorIso: string): string {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1_000);
    return () => clearInterval(id);
  }, []);

  const anchorMs = new Date(anchorIso).getTime();
  const elapsedSeconds = (now - anchorMs) / 1_000;

  return formatElapsed(elapsedSeconds);
}
